<template>
    <div class="help-container">
      <h2 class="help-title">Ayuda para Gestión de Médicos</h2>
      <p class="help-introduction">Esta sección permite administrar los registros de los médicos dentro de la aplicación. Aquí puedes realizar varias acciones relacionadas con la gestión de los médicos.</p>
      <ul class="help-list">
        <li><strong>Visualizar Información del Médico:</strong> Al ingresar a la sección, podrás ver la información detallada del médico seleccionado, incluyendo especialidad, documento y datos personales.</li>
        <li><strong>Editar Información del Médico:</strong> Si necesitas modificar cualquier dato del médico, puedes hacerlo a través del formulario proporcionado, cambiando los campos necesarios y seleccionando la opción "Actualizar".</li>
        <li><strong>Añadir Nuevo Médico:</strong> Si deseas añadir un nuevo médico, puedes hacer clic en el botón "Nuevo registro" que te permitirá llenar los datos del nuevo profesional de la salud.</li>
        <li><strong>Seleccionar Persona:</strong> Puedes vincular a una persona existente con el médico mediante el desplegable de personas, el cual está deshabilitado si estás en modo edición.</li>
        <li><strong>Asignar Especialidad:</strong> Es posible asignar o cambiar la especialidad del médico utilizando el desplegable correspondiente que lista todas las especialidades disponibles.</li>
      </ul>
      <p class="help-conclusion">Recuerda que la actualización y precisión de la información médica es crucial para el correcto funcionamiento de la gestión clínica dentro de la aplicación.</p>
    </div>
  </template>
  
  <script>
  export default {
    name: "AyudaMedico",
  };
  </script>
  
  <style src="@/assets/css/ayuda.css" scoped></style>
